import React, { Component } from 'react';
import NamePhoneSearchResultItem from './NamePhoneSearchResultItem';
import { IDisplaySearchResultItemConfiguration } from './SearchResultUtils';

class MedicalProviderSearchResultItem extends Component<IDisplaySearchResultItemConfiguration> {
  public render () {
    const displayItemConfiguration: IDisplaySearchResultItemConfiguration = {
      ...this.props,
      entity: 'medicalprovider',
      path: '/contacts/people/',
    };

    return (
      <NamePhoneSearchResultItem { ...displayItemConfiguration } />
    );
  }
}

export default MedicalProviderSearchResultItem;
